import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, FormControl } from '@mui/material';

const AudienceSelectWidget = (props) => {
    const { setValue, value, fieldDefinition } = props;
    const audiences = fieldDefinition?.fieldSettings?.audiences || [];

    const [selectedAudience, setSelectedAudience] = useState(null);

    useEffect(() => {
        if (value && audiences.length > 0) {
            const found = audiences.find(a => a.id === value);
            setSelectedAudience(found || null);
        }
    }, [value, audiences]);

    const handleChange = (event, newValue) => {
        setSelectedAudience(newValue);
        setValue(newValue ? newValue.id : null);
    };

    return (
        <FormControl sx={{ minWidth: 250 }}>
            <Autocomplete
                options={audiences}
                getOptionLabel={(option) => option.name || ''}
                value={selectedAudience}
                onChange={handleChange}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        size="small"
                        placeholder="Select audience..."
                        sx={{
                            '& .MuiInputBase-root': {
                                minHeight: '40px'
                            }
                        }}
                    />
                )}
                ListboxProps={{
                    style: { maxHeight: '300px', zIndex: 35001 }
                }}
                componentsProps={{
                    popper: {
                        style: { zIndex: 35001 }
                    }
                }}
                size="small"
            />
        </FormControl>
    );
};

export default AudienceSelectWidget;
